import { t } from 'i18next'
import * as React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { Action, mk_widget, Widget } from 'widgets-for-react'
import { HeaderState, ViewPortSize, defaultLanguage, localeTranslations, oldSites } from '../../../public_site.main.mod'
import { ParsedNode } from '../../drupal/types_and_parser/types'
import {
  //updateUrlLang,
  addLangToUrl,
  updateUrlLang,
  getLangFromUrl
} from '../utils/history.mod'
import { Language, CustomParsedNode } from '../../drupal/types_and_parser/extra_types.mod'
import { isLinkExternal } from '../../cms/blocks/utils.gen'
import { getCookie, setCookie } from '../../cms/blocks/cookiebar.utils.mod'
import { switchLanguageDatalayer } from '../../datalayer'
import { getRegions } from '../../drupal/api/api.mod'
import StickyHeader from '../utils/stickyHeader'
import { clickoutside } from '../../helpers'

export type RenderFunction = (ss: ViewPortSize) => JSX.Element

const selectRegion = (url: string) => {
  setCookie('selectedRegion', url, 14)
  document.location.href = url
}

export const selectRegionNoRedirect = (url: string) => {
  setCookie('selectedRegion', url, 14)
}

export const header: (_: HeaderState) => Widget<Action<HeaderState>> = (props) =>
  mk_widget({
    run: (setState) => {
      const isMenuOpen: boolean = window.innerWidth > convertEmToPx(64) ? true : props.mode === 'open' ? true : false
      const toggleCountriesNav: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void = (_) => {
        setState((s) => ({
          ...s,
          countriesNav: s.countriesNav == 'open' ? 'closed' : 'open',
          hoveredPrimMenuItem: null,
          hoveredSecMenuItem: null
        }))
        if (document.documentElement.classList.contains('disable-scroll')) {
          document.documentElement.classList.remove('disable-scroll')
        } else {
          document.documentElement.classList.add('disable-scroll')
        }
      }
      const toggleSearchNav: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void = (_) =>
        setState((s) => ({
          ...s,
          searchNav: s.searchNav == 'open' ? 'closed' : 'open',
          hoveredPrimMenuItem: null,
          hoveredSecMenuItem: null
        }))

      const closeFlyout = () => {
        setState((s1) => ({
          ...s1,
          hoveredPrimMenuItem: undefined,
          hoveredSecMenuItem: undefined,
          hoveredTretMenuItem: undefined
        }))
      }

      const header = document.querySelector('#io-header') as HTMLElement

      if (header) {
        clickoutside(header, () => {
          document.documentElement.classList.remove('nav--toggled')
        })
      }

      const getLinkUrl = (url: string) => {
        if (isLinkExternal(url)) return { pathname: url }
        return updateUrlLang(url, getLangFromUrl())
      }

      const getLinkTarget = (url: string) => {
        if (isLinkExternal(url)) return '_blank'
        return '_self'
      }

      // const cookieData = getCookie('locale')
      const regionCookie = getCookie('selectedRegion')

      const refrescoBranding =
        props.node != 'none' && props.node.bundle == 'page' ? props.node.field_refresco_branding : false

      return !refrescoBranding ? (
        <>
          {/* A11y Skiplinks */}
          <a href="#a11y-main" className="sr-text">
            {t('Header:A11y.SkipToContent')}
          </a>
          <a href="#a11y-footer" className="sr-text">
            {t('Header:A11y.SkipToFooter')}
          </a>
          <StickyHeader
            className={`header ${props.isTransparent ? 'header--transparent' : ''}`}
            innerClassName="header__wrapper"
            scrollingUp="header--scrolling-up"
            scrollingDown="header--scrolling-down"
            pinned="header--pinned"
            onMouseLeave={closeFlyout}
          >
            <div className="header__top-bar top-nav" key={`header-language-${props.countriesNav}`}>
              <nav className="nav nav--top">
                <div className="nav__inner container container--m grid--gutter">
                  <ul className="nav__list">
                    <li className="nav__item">
                      <Link className="nav__link" to={`/${getLangFromUrl()}/${t('header:contact_url')}`}>
                        {t('header:contact')}
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="header__inner container container--m grid--gutter">
              <Link to={addLangToUrl('/')} className="header__logo" onClick={closeFlyout}>
                <span className="sr-text">{t('Header:ReturnToHome')}</span>
                <svg
                  className="header__logo logo"
                  height="77"
                  viewBox="0 0 227 77"
                  width="227"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="logo__arc"
                    d="m226.3 29s-.8-.4-2.4-1c-1.6-.7-3.9-1.5-6.9-2.6-1.5-.5-3.1-1.1-5-1.7-1.8-.6-3.8-1.3-5.9-1.9-1.1-.3-2.1-.7-3.3-1-1.1-.3-2.3-.6-3.5-1-1.2-.3-2.4-.7-3.7-1s-2.5-.6-3.9-1c-1.3-.3-2.6-.7-4-1s-2.8-.6-4.2-.9-2.9-.6-4.3-1c-1.5-.3-3-.6-4.5-.8-1.5-.3-3.1-.6-4.6-.9-1.6-.2-3.1-.5-4.7-.7-1.6-.3-3.2-.5-4.8-.8-1.6-.2-3.3-.4-5-.6-3.3-.4-6.7-.9-10.2-1.1-1.7-.2-3.5-.3-5.2-.5s-3.5-.3-5.3-.4-3.5-.2-5.3-.3-3.5-.2-5.3-.2c-3.6-.1-7.1-.1-10.7-.2-3.6.1-7.2.1-10.8.2-1.8 0-3.6.1-5.3.2-1.8.1-3.5.2-5.3.3-1.7.1-3.5.2-5.2.4s-3.5.3-5.2.5c-3.5.2-6.8.7-10.2 1.1-1.7.2-3.3.4-5 .6-1.6.3-3.2.5-4.8.8s-3.2.5-4.7.7c-1.6.3-3.1.6-4.6.9s-3 .6-4.5.8c-1.5.3-2.9.6-4.3 1-1.4.3-2.8.6-4.2.9s-2.7.7-4 1-2.6.6-3.9 1c-1.2.3-2.5.7-3.7 1s-2.4.6-3.5 1c-1.1.3-2.2.7-3.3 1-2.1.6-4.1 1.3-5.9 1.9s-3.5 1.2-5 1.7c-3 1.1-5.3 2-6.9 2.6s-2.4 1-2.4 1 .7-.5 2.2-1.4 3.6-2.2 6.4-3.7 6.3-3.3 10.4-5c1-.4 2.1-.9 3.2-1.4s2.2-.9 3.4-1.4 2.4-.9 3.6-1.4c1.2-.4 2.5-.9 3.8-1.4s2.6-.9 4-1.4c1.4-.4 2.8-.9 4.2-1.3s2.9-.9 4.3-1.3c1.5-.4 3-.8 4.5-1.2s3.1-.8 4.7-1.2c1.6-.3 3.2-.7 4.8-1.1 1.6-.3 3.3-.7 4.9-1.1 1.7-.3 3.4-.6 5.1-.9s3.4-.6 5.1-.9 3.5-.5 5.2-.7c3.5-.4 7.1-1 10.7-1.2 1.8-.1 3.6-.3 5.5-.4 1.8-.1 3.7-.3 5.5-.3 3.6-.1 7.3-.2 11-.3 3.7.1 7.4.2 11 .3 1.8 0 3.7.2 5.5.3s3.6.3 5.4.4c3.6.2 7.2.7 10.7 1.2 1.8.2 3.5.4 5.2.7s3.4.6 5.1.9 3.4.6 5.1.9c1.7.4 3.3.7 4.9 1.1s3.2.7 4.8 1.1 3.1.8 4.7 1.2c1.5.4 3 .8 4.5 1.2s2.9.9 4.3 1.3 2.8.9 4.2 1.3c1.4.5 2.7.9 4 1.4s2.6.9 3.8 1.4 2.4 1 3.6 1.4c1.2.5 2.3.9 3.4 1.4s2.1.9 3.2 1.4c2.1.9 3.9 1.8 5.7 2.6 1.7.8 3.3 1.7 4.7 2.4 2.8 1.5 5 2.8 6.5 3.7 1.8.8 2.6 1.4 2.6 1.4z"
                  />
                  <g className="logo__logotype">
                    <path d="m25 40.4c5.5.4 8.4 3.4 8.4 6.4 0 6.3-6.5 6.6-8.4 6.8zm-8.2 24.7c0 3.6-.2 6.6-1.1 10.7h10.5c-1.1-4.4-1.2-5.7-1.2-8.9v-7.5c8.6 11.4 9.6 11.6 15.1 16.4h7.5c-4.9-5.9-10.6-12-14.3-18.5 1.9-1 9.1-2.1 9.1-11 0-5.6-3.4-12-16.3-11.8l-10.5.1c.4 1.4 1.1 3.7 1.1 8.6z" />
                    <path d="m53.9 58.4c0-3 2.2-7 5.2-7 2.4 0 4.5 2.6 4.5 7zm15.7 10.1c-3.3 1.5-4.3 2-6.6 2-6.4 0-8.1-5.5-8.3-7.5h15.2c0-3.1.4-5.3 0-7.6-.8-5.5-5.8-9-10.5-9-6.8 0-12.2 5.9-12.2 15.5 0 6.5 4.8 14.9 14 14.9 2.7 0 4.3-1 6.1-1.6z" />
                    <path d="m89 52.2h-6v16.6c0 4 .7 5.4 1.5 6.9l-9.7.1c1.3-2.4 1.6-4.4 1.6-7.4v-16.2l-4.1-.1c1.1-1.4 2.6-5 2.6-5h1.5v-1.7c0-4.2 1.4-11 9.5-11 2.1 0 4.7.7 6.2 1-.6 2.8-.7 2.9-1.1 5.6-.7-1.4-2.3-1.6-4.2-1.6-2.2 0-3.8 2.8-3.8 4.5v3h6z" />
                    <path d="m102.8 46.9c-.3 1.5-.3 2.1-.3 4v1.4c2.9-4.2 4.4-6.1 6.6-6.1 1.2 0 2.1.6 3 1l-.9 6.6c-1-1-1.8-1.5-2.9-1.5-3 0-4.6 3-5.7 4.1v12.6c0 4.2.4 5.1 1.4 6.8h-10.3c1.2-1.8 1.4-2.8 1.4-5.5v-18.4c0-1 0-2.3-.9-5z" />
                    <path d="m121.2 58.4c.4-4.9 2.5-7 4.5-7 2.2 0 4.4 1.8 4.2 7zm15.1 10.1c-3.3 1.5-3.7 2-6 2-6.4 0-8.4-5.5-8.6-7.5l15.2-.3c0-3.1.1-5.3-.3-7.6-.8-5.5-5.5-8.7-10.2-8.7-6.8 0-12.2 5.6-12.2 15.2 0 6.5 3.8 14.9 13.1 14.9 2.7 0 4.6-.7 6.4-1.3z" />
                    <path d="m156 52.8c-1.2-1-3.1-1.3-4.4-1.3-1.7 0-3.6 1.2-3.6 2.6 0 2.2 1.9 3.3 4 4.9 2.9 2.2 4.4 4.6 4.4 8.6 0 4.9-3.3 8.9-9.4 8.9-.7 0-3.4-.3-7-1.4l.1-6.8c2.7 2.4 5 3.2 6.7 3.2s3-1.1 3-2.7c0-1.3-.7-2.5-3.4-4.8-1.7-1.5-5.5-4.3-5.5-8.9 0-3.2 2.8-8.7 9.7-8.7 2.3 0 3.5.4 5.5 1.2v5.2z" />
                    <path d="m180.4 54.1c-.5-.6-2.3-2.7-5.7-2.7-5.9 0-7.6 6.1-7.6 9.7 0 7 6.3 9.4 8.7 9.4 2.5 0 4.7-1 6.1-1.8l-2.8 7.2c-1.5.3-4.2.4-6.3.4-7.1 0-13.4-6.8-13.4-13.6 0-6.1 3.2-16.2 15.9-16.2 2.5 0 4.3.6 5.8.9z" />
                    <path d="m200.1 71.5c-4.9.4-8.7-6.2-8.7-10.4s2.9-10 4.3-10c3 0 8.2 3.5 8.2 10.5 0 6.5-3 9.3-3.8 9.9zm-4.2-25.2c-4.7 1.4-11.6 4.2-11.6 16.3 0 10 7.8 14 13.5 14 3.5 0 14.1-3.6 14.1-16.1-.1-8.6-8.1-14.5-16-14.2z" />
                  </g>
                </svg>
              </Link>
              <nav
                className="header__nav nav nav--main nav--mobile"
                id="a11y-main-menu-collapse"
                nav--mobile
                aria-hidden={!isMenuOpen}
              >
                {props.menuHeader.navLinks.kind == 'loaded' ? (
                  // Primary
                  <ul className="nav__list nav__list--primary">
                    {props.menuHeader.navLinks.value.map((primaryItem) => (
                      <li className="nav__item" key={`main-nav-${primaryItem.url}`}>
                        {primaryItem.children ? (
                          <>
                            <Link
                              className={`nav__link${
                                props.hoveredPrimMenuItem == primaryItem ? ' nav__link--active' : ''
                              }`}
                              onClick={(_) => {
                                document.documentElement.classList.remove('nav--toggled')
                                closeFlyout()
                              }}
                              to={getLinkUrl(primaryItem.url)}
                              target={getLinkTarget(primaryItem.url)}
                            >
                              {primaryItem.label}
                            </Link>
                            <button
                              className={`nav__button${
                                props.hoveredPrimMenuItem == primaryItem ? ' nav__button--toggled' : ''
                              }`}
                              onClick={(_) =>
                                setState((s1) => ({
                                  ...s1,
                                  hoveredPrimMenuItem:
                                    props.hoveredPrimMenuItem == primaryItem ? undefined : primaryItem
                                }))
                              }
                            ></button>
                            {/* Secondary */}
                            <ul className={`sublist sublist--${props.hoveredPrimMenuItem ? 'shown' : 'hidden'}`}>
                              {props.hoveredPrimMenuItem == primaryItem &&
                                primaryItem.children.map((secondaryItem) => (
                                  <li
                                    className="sublist__item"
                                    onClick={(event) => {
                                      event.stopPropagation()
                                      setState((s1) => ({ ...s1, hoveredSecMenuItem: secondaryItem }))
                                    }}
                                  >
                                    <Link
                                      onClick={(_) => {
                                        document.documentElement.classList.remove('nav--toggled')
                                        closeFlyout()
                                      }}
                                      to={getLinkUrl(secondaryItem.url)}
                                      target={getLinkTarget(secondaryItem.url)}
                                      className="sublist__link"
                                    >
                                      {secondaryItem.label}
                                    </Link>
                                  </li>
                                ))}
                            </ul>
                          </>
                        ) : (
                          <>
                            <NavLink
                              className="nav__link"
                              activeClassName="nav__link--active"
                              to={getLinkUrl(primaryItem.url)}
                              target={getLinkTarget(primaryItem.url)}
                              onClick={closeFlyout}
                            >
                              {primaryItem.label}
                            </NavLink>
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <>&nbsp;</>
                )}
              </nav>

              <nav className="header__nav nav nav--main nav--desktop" id="a11y-main-menu">
                {props.menuHeader.navLinks.kind == 'loaded' ? (
                  <ul className="nav__list nav__list--primary">
                    {/* Primary */}
                    {props.menuHeader.navLinks.value.map((primaryItem, primaryIndex) => (
                      <li
                        className="nav__item"
                        key={`main-nav-${primaryItem.url}`}
                        onMouseEnter={(_) =>
                          setState((s1) => ({
                            ...s1,
                            hoveredPrimMenuItem: primaryItem,
                            hoveredSecMenuItem: null
                          }))
                        }
                      >
                        <NavLink
                          className="nav__link"
                          activeClassName="nav__link--active"
                          onClick={closeFlyout}
                          to={getLinkUrl(primaryItem.url)}
                          target={getLinkTarget(primaryItem.url)}
                        >
                          {primaryItem.label}
                          {primaryItem?.children?.count() > 0 && (
                            <svg className="nav__chevron" aria-hidden="true" height="8" width="13">
                              <use xlinkHref="#chevron--down" />
                            </svg>
                          )}
                        </NavLink>
                        {primaryItem?.children?.count() > 0 && (
                          <ul className={`sublist`}>
                            {primaryItem.children.map((secondaryItem) => (
                              <li
                                className="sublist__item"
                                onClick={(event) => {
                                  setState((s1) => ({ ...s1, hoveredSecMenuItem: secondaryItem }))
                                }}
                                onMouseEnter={(_) => setState((s1) => ({ ...s1, hoveredSecMenuItem: secondaryItem }))}
                              >
                                <Link
                                  onClick={(_) => {
                                    document.documentElement.classList.remove('nav--toggled')
                                    closeFlyout()
                                  }}
                                  to={getLinkUrl(secondaryItem.url)}
                                  target={getLinkTarget(secondaryItem.url)}
                                  className="sublist__link"
                                >
                                  {secondaryItem.label}
                                  {secondaryItem?.children?.count() > 0 && (
                                    <svg className="nav__chevron" aria-hidden="true" height="8" width="13">
                                      <use xlinkHref="#chevron--down" />
                                    </svg>
                                  )}
                                </Link>
                                {secondaryItem?.children?.count() > 0 && (
                                  <ul className={`sublist sublist--tertiary`}>
                                    {secondaryItem.children.map((tretMenuItem) => (
                                      <li className="sublist__item">
                                        <Link
                                          className="sublist__link"
                                          to={getLinkUrl(tretMenuItem.url)}
                                          target={getLinkTarget(tretMenuItem.url)}
                                          onClick={closeFlyout}
                                        >
                                          {tretMenuItem.label}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <>&nbsp;</>
                )}
              </nav>
              <div className="header__actions">
                <button className="header__lang" onClick={toggleCountriesNav}>
                  <svg className="header__lang-icon" height="22" width="22">
                    <use xlinkHref="#icon--lang" />
                  </svg>
                  <span className="sr-text">{t('header:international')}</span>
                </button>

                <button
                  className="header__toggler"
                  onClick={(event) => {
                    document.documentElement.classList.toggle('nav--toggled')
                  }}
                  aria-controls="a11y-main-menu-collapse"
                  aria-expanded={isMenuOpen}
                >
                  <span className="sr-text">{t(`Header:Menu.${isMenuOpen ? 'Open' : 'Closed'}`)}</span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </button>

                <button
                  className="header__search"
                  onClick={(event) => {
                    toggleSearchNav(event)
                  }}
                  aria-controls="a11y-search-collapse"
                  aria-expanded="false"
                >
                  <span className="sr-text">search.open</span>
                  <svg className="header__search-icon" height="22" width="22">
                    <use xlinkHref="#icon--search" />
                  </svg>
                </button>
              </div>
            </div>

            <div
              className={`languages languages--${
                props.countriesNav == 'open' || (regionCookie == '' && document.location.href == oldSites.get('en'))
                  ? 'visible'
                  : 'hidden'
              }`}
            >
              <div className="container container--m grid--gutter">
                <header className="languages__header">
                  <button className="languages__toggler" onClick={(event) => toggleCountriesNav(event)}>
                    <span className="sr-text">Close overlay</span>
                    <svg className="languages__button--icon" aria-hidden="true" height="30" width="32">
                      <use xlinkHref="#icon--close-circled" />
                    </svg>
                  </button>
                  <div className="header__logo">
                    <img
                      className="languages__logo"
                      src="/frontend/images/logo.svg"
                      alt="Refresco"
                      width="227"
                      height="77"
                    />
                  </div>
                </header>
                <div className="languages__inner container--s">
                  <div className="languages__message">
                    <p className="languages__intro">{t('header:visiting_current_page_intro')}</p>
                    <button
                      className="languages__cta button button--primary"
                      onClick={(e) => {
                        setCookie('locale', defaultLanguage, 1000)
                        switchLanguageDatalayer(localeTranslations.get(defaultLanguage), window.location.pathname)
                        const selectedRegionhref = `/global/`
                        let url = oldSites.get(selectedRegionhref.replace(/\//g, '') as any)
                        if (getLangFromUrl() != 'en' && getLangFromUrl() != 'global') {
                          url += '?clearcookie=true'
                        }
                        selectRegion(url)
                      }}
                    >
                      {t('header:link_to_refresco_group')}
                    </button>
                  </div>
                  <nav className="languages__nav nav nav--countries">
                    <ul className="nav__list">
                      {getRegions()
                        .filter((r) => r.languages.length > 0)
                        .map((region, count) => {
                          const defaultRegionLanguage = region.languages[0]
                          const restLanguages = region.languages.splice(1)
                          return (
                            <li className="nav__item" key={`region-selector-${count}-${defaultRegionLanguage.locale}`}>
                              <div className="nav__header">
                                <p className="nav__title text--l">{region.title}</p>
                                {region.flags && region.flags.length > 0 && (
                                  <div className="nav__flags">
                                    {region.flags.map((flag) => (
                                      <svg className="nav__flag" aria-hidden="true" width="26" height="20">
                                        <use xlinkHref={flag} />
                                      </svg>
                                    ))}
                                  </div>
                                )}
                              </div>

                              <div className="nav__languages">
                                <button
                                  className={`nav__link nav__link--${defaultRegionLanguage.locale}`}
                                  onClick={(e) => {
                                    const selectedRegionhref =
                                      defaultRegionLanguage.locale == 'global'
                                        ? `/global/`
                                        : `/${defaultRegionLanguage.locale}/`
                                    const key = selectedRegionhref.replace(/\//g, '') as any
                                    if (oldSites.has(key)) {
                                      setCookie(
                                        'locale',
                                        defaultRegionLanguage.locale == 'global' ? 'en' : defaultRegionLanguage.locale,
                                        1000
                                      )
                                      switchLanguageDatalayer(
                                        localeTranslations.get(defaultRegionLanguage.locale),
                                        window.location.pathname
                                      )
                                      const url = oldSites.get(key)
                                      // if(getLangFromUrl() != "en" && getLangFromUrl() != "global"){
                                      //   url += "?clearcookie=true"
                                      // }
                                      selectRegion(url)
                                    }
                                  }}
                                >
                                  <svg className="nav__icon" height="24" width="16">
                                    <use xlinkHref="#icon--arrow" />
                                  </svg>
                                  <span className="nav__language">{defaultRegionLanguage.name}</span>
                                </button>

                                {restLanguages.length > 0
                                  ? restLanguages.map((l) => (
                                      <button
                                        className={`nav__link nav__link--${defaultRegionLanguage.locale}`}
                                        onClick={(e) => {
                                          const selectedRegionhref = l.locale == 'global' ? `/en/` : `/${l.locale}/`
                                          const key = selectedRegionhref.replace(/\//g, '') as any
                                          if (oldSites.has(key)) {
                                            setCookie('locale', l.locale == 'global' ? 'global' : l.locale, 1000)
                                            switchLanguageDatalayer(
                                              localeTranslations.get(l.locale),
                                              window.location.pathname
                                            )
                                            const url = oldSites.get(key)
                                            selectRegion(url)
                                          }
                                        }}
                                      >
                                        <svg className="nav__icon" height="24" width="16">
                                          <use xlinkHref="#icon--arrow" />
                                        </svg>
                                        <span className="nav__language">{l.name}</span>
                                      </button>
                                    ))
                                  : null}
                              </div>
                            </li>
                          )
                        })}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <div
              className={`search search--${props.searchNav == 'open' ? 'show' : 'hidden'}`}
              key={`search-${props.searchNav}`}
            >
              <div className="search__inner container container--m grid--gutter">
                <form
                  onSubmit={(e) => {
                    e.preventDefault()
                    location.href = `/${props.currentLanguage}/search/${props.searchQuery}/0`
                  }}
                  className="search__form"
                >
                  <input
                    autoFocus
                    type="search"
                    value={props.searchQuery}
                    onChange={(e) => setState((s1) => ({ ...s1, searchQuery: e.currentTarget.value }))}
                    className="search__input"
                  />
                </form>
                <button className="search__button" onClick={toggleSearchNav}>
                  <span className="sr-text">Closing search's button</span>
                </button>
              </div>
            </div>
          </StickyHeader>
        </>
      ) : (
        <></>
      )
    }
  })

export const convertEmToPx = (em: number) => parseFloat(getComputedStyle(document.documentElement).fontSize) * em

const get_translated_url: (node: ParsedNode | CustomParsedNode | 'none', lang: Language) => string = (node, lang) =>
  node != 'none' && node.bundle != 'homepage' && node.language_links != undefined && node.language_links.has(lang)
    ? node.language_links.get(lang)
    : `/${lang}/`

export const language_links: (_: HeaderState) => Widget<Action<HeaderState>> = (props) =>
  mk_widget({
    run: (_) => {
      return (
        <select
          value={
            props.currentLanguage == 'na-fr' ? 'fr' : props.currentLanguage == 'na-es' ? 'es' : props.currentLanguage
          }
          // defaultValue={props.currentLanguage == 'na-fr' ? 'fr' : props.currentLanguage == 'na-es' ? 'es' : props.currentLanguage}
          onChange={(e) => {
            const lang: Language = e.currentTarget.value as Language

            // gtm({ category: 'Language', action: lang.toUpperCase() })

            let url: string = get_translated_url(props.node, lang)
            url = url.replace('/en/', '/na/').replace('/fr/', '/na-fr/').replace('/es/', '/na-es/')

            window.location.href = url
          }}
        >
          <option value={'en'} key={'lang-en'}>
            {'EN'}
          </option>
          <option value={'fr'} key={'lang-fr'}>
            {'FR'}
          </option>
          {/* <option value={'es'} key = {'lang-es'}>{'ES'}</option> */}
        </select>
      )
    }
  })

export const productdetailpageHeader: (_: HeaderState) => Widget<Action<HeaderState>> = (props) =>
  mk_widget({
    run: (onDone) => {
      const isMenuOpen: boolean = window.innerWidth > convertEmToPx(64) ? true : props.mode === 'open' ? true : false
      return (
        <header className="header">
          <div className="header__inner">
            <div className="header__toolbar">
              <div className="header__logo-toggler">
                <Link to={addLangToUrl('/')} className="header__logo">
                  <span className="sr-text">{t('Header:returnToHome')}</span>
                  <svg
                    className="header__logo logo"
                    height="77"
                    viewBox="0 0 227 77"
                    width="227"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m226.3 29s-.8-.4-2.4-1c-1.6-.7-3.9-1.5-6.9-2.6-1.5-.5-3.1-1.1-5-1.7-1.8-.6-3.8-1.3-5.9-1.9-1.1-.3-2.1-.7-3.3-1-1.1-.3-2.3-.6-3.5-1-1.2-.3-2.4-.7-3.7-1s-2.5-.6-3.9-1c-1.3-.3-2.6-.7-4-1s-2.8-.6-4.2-.9-2.9-.6-4.3-1c-1.5-.3-3-.6-4.5-.8-1.5-.3-3.1-.6-4.6-.9-1.6-.2-3.1-.5-4.7-.7-1.6-.3-3.2-.5-4.8-.8-1.6-.2-3.3-.4-5-.6-3.3-.4-6.7-.9-10.2-1.1-1.7-.2-3.5-.3-5.2-.5s-3.5-.3-5.3-.4-3.5-.2-5.3-.3-3.5-.2-5.3-.2c-3.6-.1-7.1-.1-10.7-.2-3.6.1-7.2.1-10.8.2-1.8 0-3.6.1-5.3.2-1.8.1-3.5.2-5.3.3-1.7.1-3.5.2-5.2.4s-3.5.3-5.2.5c-3.5.2-6.8.7-10.2 1.1-1.7.2-3.3.4-5 .6-1.6.3-3.2.5-4.8.8s-3.2.5-4.7.7c-1.6.3-3.1.6-4.6.9s-3 .6-4.5.8c-1.5.3-2.9.6-4.3 1-1.4.3-2.8.6-4.2.9s-2.7.7-4 1-2.6.6-3.9 1c-1.2.3-2.5.7-3.7 1s-2.4.6-3.5 1c-1.1.3-2.2.7-3.3 1-2.1.6-4.1 1.3-5.9 1.9s-3.5 1.2-5 1.7c-3 1.1-5.3 2-6.9 2.6s-2.4 1-2.4 1 .7-.5 2.2-1.4 3.6-2.2 6.4-3.7 6.3-3.3 10.4-5c1-.4 2.1-.9 3.2-1.4s2.2-.9 3.4-1.4 2.4-.9 3.6-1.4c1.2-.4 2.5-.9 3.8-1.4s2.6-.9 4-1.4c1.4-.4 2.8-.9 4.2-1.3s2.9-.9 4.3-1.3c1.5-.4 3-.8 4.5-1.2s3.1-.8 4.7-1.2c1.6-.3 3.2-.7 4.8-1.1 1.6-.3 3.3-.7 4.9-1.1 1.7-.3 3.4-.6 5.1-.9s3.4-.6 5.1-.9 3.5-.5 5.2-.7c3.5-.4 7.1-1 10.7-1.2 1.8-.1 3.6-.3 5.5-.4 1.8-.1 3.7-.3 5.5-.3 3.6-.1 7.3-.2 11-.3 3.7.1 7.4.2 11 .3 1.8 0 3.7.2 5.5.3s3.6.3 5.4.4c3.6.2 7.2.7 10.7 1.2 1.8.2 3.5.4 5.2.7s3.4.6 5.1.9 3.4.6 5.1.9c1.7.4 3.3.7 4.9 1.1s3.2.7 4.8 1.1 3.1.8 4.7 1.2c1.5.4 3 .8 4.5 1.2s2.9.9 4.3 1.3 2.8.9 4.2 1.3c1.4.5 2.7.9 4 1.4s2.6.9 3.8 1.4 2.4 1 3.6 1.4c1.2.5 2.3.9 3.4 1.4s2.1.9 3.2 1.4c2.1.9 3.9 1.8 5.7 2.6 1.7.8 3.3 1.7 4.7 2.4 2.8 1.5 5 2.8 6.5 3.7 1.8.8 2.6 1.4 2.6 1.4z"
                      fill="#04a64a"
                    />
                    <g fill="#f49612">
                      <path d="m25 40.4c5.5.4 8.4 3.4 8.4 6.4 0 6.3-6.5 6.6-8.4 6.8zm-8.2 24.7c0 3.6-.2 6.6-1.1 10.7h10.5c-1.1-4.4-1.2-5.7-1.2-8.9v-7.5c8.6 11.4 9.6 11.6 15.1 16.4h7.5c-4.9-5.9-10.6-12-14.3-18.5 1.9-1 9.1-2.1 9.1-11 0-5.6-3.4-12-16.3-11.8l-10.5.1c.4 1.4 1.1 3.7 1.1 8.6z" />
                      <path d="m53.9 58.4c0-3 2.2-7 5.2-7 2.4 0 4.5 2.6 4.5 7zm15.7 10.1c-3.3 1.5-4.3 2-6.6 2-6.4 0-8.1-5.5-8.3-7.5h15.2c0-3.1.4-5.3 0-7.6-.8-5.5-5.8-9-10.5-9-6.8 0-12.2 5.9-12.2 15.5 0 6.5 4.8 14.9 14 14.9 2.7 0 4.3-1 6.1-1.6z" />
                      <path d="m89 52.2h-6v16.6c0 4 .7 5.4 1.5 6.9l-9.7.1c1.3-2.4 1.6-4.4 1.6-7.4v-16.2l-4.1-.1c1.1-1.4 2.6-5 2.6-5h1.5v-1.7c0-4.2 1.4-11 9.5-11 2.1 0 4.7.7 6.2 1-.6 2.8-.7 2.9-1.1 5.6-.7-1.4-2.3-1.6-4.2-1.6-2.2 0-3.8 2.8-3.8 4.5v3h6z" />
                      <path d="m102.8 46.9c-.3 1.5-.3 2.1-.3 4v1.4c2.9-4.2 4.4-6.1 6.6-6.1 1.2 0 2.1.6 3 1l-.9 6.6c-1-1-1.8-1.5-2.9-1.5-3 0-4.6 3-5.7 4.1v12.6c0 4.2.4 5.1 1.4 6.8h-10.3c1.2-1.8 1.4-2.8 1.4-5.5v-18.4c0-1 0-2.3-.9-5z" />
                      <path d="m121.2 58.4c.4-4.9 2.5-7 4.5-7 2.2 0 4.4 1.8 4.2 7zm15.1 10.1c-3.3 1.5-3.7 2-6 2-6.4 0-8.4-5.5-8.6-7.5l15.2-.3c0-3.1.1-5.3-.3-7.6-.8-5.5-5.5-8.7-10.2-8.7-6.8 0-12.2 5.6-12.2 15.2 0 6.5 3.8 14.9 13.1 14.9 2.7 0 4.6-.7 6.4-1.3z" />
                      <path d="m156 52.8c-1.2-1-3.1-1.3-4.4-1.3-1.7 0-3.6 1.2-3.6 2.6 0 2.2 1.9 3.3 4 4.9 2.9 2.2 4.4 4.6 4.4 8.6 0 4.9-3.3 8.9-9.4 8.9-.7 0-3.4-.3-7-1.4l.1-6.8c2.7 2.4 5 3.2 6.7 3.2s3-1.1 3-2.7c0-1.3-.7-2.5-3.4-4.8-1.7-1.5-5.5-4.3-5.5-8.9 0-3.2 2.8-8.7 9.7-8.7 2.3 0 3.5.4 5.5 1.2v5.2z" />
                      <path d="m180.4 54.1c-.5-.6-2.3-2.7-5.7-2.7-5.9 0-7.6 6.1-7.6 9.7 0 7 6.3 9.4 8.7 9.4 2.5 0 4.7-1 6.1-1.8l-2.8 7.2c-1.5.3-4.2.4-6.3.4-7.1 0-13.4-6.8-13.4-13.6 0-6.1 3.2-16.2 15.9-16.2 2.5 0 4.3.6 5.8.9z" />
                      <path d="m200.1 71.5c-4.9.4-8.7-6.2-8.7-10.4s2.9-10 4.3-10c3 0 8.2 3.5 8.2 10.5 0 6.5-3 9.3-3.8 9.9zm-4.2-25.2c-4.7 1.4-11.6 4.2-11.6 16.3 0 10 7.8 14 13.5 14 3.5 0 14.1-3.6 14.1-16.1-.1-8.6-8.1-14.5-16-14.2z" />
                    </g>
                  </svg>
                </Link>

                <button
                  className="header__toggler"
                  onClick={() => {
                    document.documentElement.classList.toggle('nav--toggled')
                    onDone((s1) => ({
                      ...s1,
                      mode: props.mode == 'open' ? 'closed' : 'open'
                    }))
                  }}
                  aria-controls="a11y-main-menu-collapse"
                  aria-expanded={isMenuOpen}
                >
                  <span className="sr-text">{t(`header:menu.${isMenuOpen ? 'open' : 'closed'}`)}</span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </button>
              </div>
            </div>

            <nav className="header__nav nav nav--header" id="a11y-main-menu-collapse" aria-hidden={!isMenuOpen}>
              {props.menuHeader.navLinks.kind == 'loaded' ? (
                <ul className="nav__items">
                  {props.menuHeader.navLinks.value.butLast().map((item) => (
                    <li className="nav__item" key={`main-nav-${item.url}`}>
                      <NavLink
                        className="nav__link--active"
                        activeClassName="nav__link--active"
                        to={
                          /*updateUrlLang( 
                          item.url,
                          props.currentLanguage,
                          props.menuHeader.languages.kind == 'loaded' ? props.menuHeader.languages.value.toArray() : [],
                          defaultLanguage
                        )*/
                          addLangToUrl(item.url)
                        }
                        onClick={() => {
                          document.documentElement.classList.remove('nav--toggled')
                          onDone((s1) => ({
                            ...s1,
                            mode: props.mode == 'open' ? 'closed' : 'open'
                          }))
                        }}
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                  <li className="nav__item">
                    <NavLink
                      className="button button--text-icon"
                      to={addLangToUrl('/contact')}
                      onClick={() => {
                        document.documentElement.classList.remove('nav--toggled')
                        onDone((s1) => ({
                          ...s1,
                          mode: props.mode == 'open' ? 'closed' : 'open'
                        }))
                      }}
                    >
                      <span className="button__label">{props.menuHeader.navLinks.value.last().label}</span>
                      <svg className="button__icon" width="1.5rem" height="1.5rem">
                        <use xlinkHref="#icon--mail" />
                      </svg>
                    </NavLink>
                  </li>
                </ul>
              ) : (
                <>&nbsp;</>
              )}
            </nav>
          </div>
        </header>
      )
    }
  })
